const colors = {
  background: {
    main: "#F7F8FA",
    section: "#FFFFFF",
  },
  navbar: {
    bg: "#FFFFFF",
    border: "#E5E7EB",
    text: "#111827",
    hover: "#4F46E5",
  },
  card: {
    bg: "#FFFFFF",
    border: "#E5E7EB",
    hover: "#FAFAFB",
    shadow: "rgba(0,0,0,0.05)",
  },
  button: {
    primaryBg: "#4F46E5",
    primaryHover: "#4338CA",
    primaryText: "#FFFFFF",
    secondaryBg: "#EEF2FF",
    secondaryHover: "#E0E7FF",
    secondaryText: "#4F46E5",
  },
  input: {
    bg: "#FFFFFF",
    border: "#D1D5DB",
    focus: "#4F46E5",
    placeholder: "#9CA3AF",
  },
  text: {
    primary: "#111827",
    secondary: "#6B7280",
    muted: "#9CA3AF",
  },
  divider: "#E5E7EB",
  footer: {
    bg: "#111827",
    text: "#E5E7EB",
    links: "#C7D2FE",
    linksHover: "#FFFFFF",
  },
  status: {
    success: "#10B981",
    warning: "#F59E0B",
    error: "#EF4444",
    info: "#3B82F6",
  },
};

export default colors;
